import React, { useState } from 'react';

export const CreditUsageInfo = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
        className="ml-0.5 sm:ml-2 text-black hover:text-gray-700 transition-colors p-0.5 inline-flex items-center justify-center flex-shrink-0"
        aria-label="Credit usage information"
        type="button"
      >
        <svg className="w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
      </button>

      {showTooltip && (
        <div className="fixed sm:absolute z-50 left-1/2 -translate-x-1/2 top-[60px] sm:top-auto sm:right-0 sm:left-auto sm:transform-none mt-2 w-[90vw] max-w-[280px] sm:w-72 bg-white rounded-lg shadow-xl border border-gray-200 p-2.5 sm:p-4">
          <div className="absolute -top-2 left-1/2 -translate-x-1/2 sm:left-auto sm:right-4 sm:translate-x-0 w-4 h-4 bg-white border-l border-t border-gray-200 rotate-45"></div>
          
          <h3 className="text-[11px] sm:text-sm font-bold text-gray-900 mb-1.5 sm:mb-3">Credit Usage</h3>
          
          <table className="w-full text-[10px] sm:text-sm">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-1 sm:py-2 text-gray-700 font-semibold text-[10px] sm:text-sm">Action</th>
                <th className="text-right py-1 sm:py-2 text-gray-700 font-semibold text-[10px] sm:text-sm">Credits</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100">
                <td className="py-1 sm:py-2 text-gray-600">
                  <span className="mr-1 text-[10px] sm:text-sm">🧩</span>
                  <span className="text-[10px] sm:text-xs">New Project</span>
                </td>
                <td className="text-right text-gray-900 font-medium text-[10px] sm:text-sm">2.0</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-1 sm:py-2 text-gray-600">
                  <span className="mr-1 text-[10px] sm:text-sm">🐞</span>
                  <span className="text-[10px] sm:text-xs">Bug Fixing</span>
                </td>
                <td className="text-right text-gray-900 font-medium text-[10px] sm:text-sm">2.0</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-1 sm:py-2 text-gray-600">
                  <span className="mr-1 text-[10px] sm:text-sm">🪄</span>
                  <span className="text-[10px] sm:text-xs">Refine Output</span>
                </td>
                <td className="text-right text-gray-900 font-medium text-[10px] sm:text-sm">1.0</td>
              </tr>
            </tbody>
          </table>
          
          <p className="text-[9px] sm:text-xs text-gray-500 mt-1.5 sm:mt-3">
            Credits deduct automatically after generation
          </p>
        </div>
      )}
    </div>
  );
};
